import { toast } from "react-hot-toast";
import { useContactSupport } from "@services/authentication";
import { Button, Modal } from "@edgelogistics/web-ui";
import { Fragment, useState } from "react";

const NeedHelpContent = ({
  onClose,
}: {
  onClose: () => void;
}): React.ReactElement => {
  const contactSupportQuery = useContactSupport("login", {
    onError: () => {
      toast.error("The contact information couldn't be obtained");
    },
  });

  return (
    <div className="h-9/10 mt-1 w-full text-center sm:mt-4 lg:mt-1">
      <h1 className="text-2xl font-medium">Need help?</h1>
      <p className="mt-5 text-sm text-gray-600">Please contact us:</p>
      <div className="mt-3 flex h-[57px] items-center justify-center">
        {contactSupportQuery.isSuccess ? (
          contactSupportQuery.data.map((contact) => (
            <div key={contact.data.email} className="text-center">
              <p className="text-tiny font-bold text-[#474747]">
                {contact.data.name}
              </p>
              <p className="text-sm text-gray-600">{contact.data.email}</p>
              <p className="text-sm text-gray-600">
                {contact.data.phone_number}
              </p>
            </div>
          ))
        ) : (
          <p className="text-sm text-gray-600">- -</p>
        )}
      </div>

      <Button className="mt-[22px] w-[57px]" onClick={onClose}>
        Ok
      </Button>
    </div>
  );
};

export const NeedHelp = (): React.ReactElement => {
  const [open, setOpen] = useState(false);

  return (
    <Fragment>
      <Button
        type="button"
        onClick={() => setOpen(true)}
        appearance="link"
        className="table w-24 truncate p-0 text-right  font-sans text-[13px]  font-semibold capitalize text-black"
      >
        Need help?
      </Button>

      <Modal
        open={open}
        content={<NeedHelpContent onClose={() => setOpen(false)} />}
        classNames={{
          content:
            "w-[255px] h-[243px] sm:[w-298px] sm:w-[298px] overflow-hidden",
          paper: "rounded-xl",
        }}
        onClose={() => setOpen(false)}
      />
    </Fragment>
  );
};
